var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-header"},[_c('div',{staticClass:"new-header-inner"},[_c('div',{staticClass:"logo"}),_vm._v(" "),_c('div',{staticClass:"slogan"},[_vm._v("消防机电工程产业生态圈")]),_vm._v(" "),_c('div',{staticClass:"back"},[_c('a',{on:{"click":_vm.handleHome}},[_vm._v("回到首页")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65c42fac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/new-header/index.vue
// module id = null
// module chunks = 